module.exports = (
  $scope,
  User
) ->
  $scope.user = User

  $scope.model =
    showExcluded: !User.hasTaggingConfigs()

  $scope.setActiveTab( 'findings' )
  $scope.setLoaded( true )
